var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"titan-language"},_vm._l((_vm.languages),function(lang){return _c('li',{class:{'titan-language-active': _vm.value === lang},on:{"click":function($event){return _vm.setValue(lang)}}},[_c('img',{staticClass:"flag-icon",attrs:{"src":'/static/flags/4x3/' + lang + '.svg',"alt":lang}})])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13016c8a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/core/Form/Fields/Language.vue
// module id = null
// module chunks = 